/* eslint-disable jsx-a11y/anchor-is-valid */
import {
	Grid,
	IconButton,
	List,
	ListItemText,
	Typography,
	useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import '../Layout.scss';
import { Link, useNavigate } from 'react-router-dom';

// import { ReactComponent as CloseIcon } from '../../common/icons/close.svg';
import CloseIcon from '@mui/icons-material/Close';

import {
	ADMIN_MENU,
	APP_ROUTES,
	AUTH_ROUTES,
	CANDIDATE_MENU,
	PUBLIC_MENU,
} from '../../common/constants/Routes';
import SvgConverter from '../../common/SvgConverter';
import LanguageSelector from '../../features/auth/LanguageSelector';
import { useDispatch } from 'react-redux';
import { logoutRequest } from '../../store/auth/_auth.slice';
import { useTranslation } from 'react-i18next';

const LeftMenuList = ({ setOpen }: { setOpen: Function }) => {
	const theme = useTheme();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [showLanguageModal, setShowLanguageModal] = useState(false);
	const [menuItems, setMenuItem] = useState(CANDIDATE_MENU);
	const handleMenuItemClick = () => {
		setOpen(false);
	};
	const handleLogOff = () => {
		setOpen(false);
		dispatch(logoutRequest(''));
		navigate(AUTH_ROUTES.LOGIN);
		window.location.reload();
	};

	const changeLanguage = () => {
		setShowLanguageModal(true);
		setOpen(false);
	};
	const roleId = localStorage.getItem('role_id');

	useEffect(() => {
		if (Number(roleId) === 1) {
			setMenuItem(ADMIN_MENU);
		} else if (Number(roleId) === 2) {
			setMenuItem(CANDIDATE_MENU);
		} else {
			setMenuItem(PUBLIC_MENU);
		}
	}, [roleId]);
	return (
		<div className="notification-container">
			<Grid
				container
				justifyContent="space-between"
				className="notification-drawer-header"
				alignItems="center"
			>
				<Grid item mt={5}>
					<Grid item mt={5}>
						<IconButton onClick={() => setOpen(false)}>
							<CloseIcon />
						</IconButton>
					</Grid>
					<Grid
						container
						justifyContent="space-between"
						alignItems="center"
						spacing={2}
					>
						<Grid item>
							<List className="left-menu-container">
								{menuItems.map((item: any, index: any) => (
									<React.Fragment key={index}>
										{item.route ? (
											<Link to={item.route} onClick={handleMenuItemClick}>
												<ListItemText
													className={`menu-item-container mt-30${
														index > 0 ? ' mt-10' : ''
													}`}
													primary={
														<Typography
															color={theme.palette.primary.main}
															fontWeight={600}
															fontSize={18}
														>
															{t(item.text)}
														</Typography>
													}
												/>
											</Link>
										) : (
											<>
												<ListItemText
													// className={`menu-item-container mt-30${
													// 	index > 0 ? ' mt-10' : ''
													// }`}
													primary={
														<Typography
															color={theme.palette.primary.main}
															fontWeight={600}
															fontSize={18}
															onClick={() => setShowLanguageModal(true)}
														>
															{t('SELECT_LANGUAGE')}
														</Typography>
													}
												/>
												<ListItemText
													className={`menu-item-container${
														index > 0 ? ' mt-10' : ''
													}`}
													primary={
														<Typography
															color={theme.palette.primary.main}
															fontWeight={600}
															fontSize={18}
															onClick={handleLogOff}
														>
															{t(item.text)}
														</Typography>
													}
												/>
											</>
										)}
									</React.Fragment>
								))}{' '}
							</List>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<LanguageSelector
				open={showLanguageModal}
				setOpen={setShowLanguageModal}
				contentType="DASHBOARD"
			/>
		</div>
	);
};

export default LeftMenuList;
